<template>
    <TopNav></TopNav>
    <h1>Calculator cu radiani</h1>
    <fieldset>
      <legend>Calculator cu radiani</legend>
      <label for="de" class="leftLabel">Grad:</label> <input type="number" v-model.number="degree" step="any" @input="onDegreeChange" autofocus id="de"> <label for="de">°</label>
      <br>
      <label for="ra" class="leftLabel">Radian:</label> <input type="number" v-model.number="radian" step="any" @input="onRadianChange" id="ra"> <label for="ra">rad</label>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "RadianConverter",
  data() {
    return {
      degree: 0,
      radian: 0
    }
  },
  components: {
    TopNav
  },
  methods: {
    onDegreeChange(e) {
      const degree = e.currentTarget.value;
      this.radian = degree * Math.PI / 180;
    },
    onRadianChange(e) {
      const radian = e.currentTarget.value;
      this.degree = radian * 180 / Math.PI;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  width: 110px;
}

footer section a {
  margin: 20px;
}
</style>
